"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdatePolicyNotes = void 0;
var swr_1 = require("swr");
var use_mutation_1 = __importDefault(require("use-mutation"));
var policy_api_1 = require("../api/policy-api");
var routes_1 = require("../bff/routes");
var useGetApiCacheKey_1 = require("../utils/hooks/useGetApiCacheKey");
// TODO: should be removed once use-mutation lib types are fixed
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/explicit-module-boundary-types
function useUpdatePolicyNotes() {
    var policyApi = policy_api_1.usePolicyApi();
    var getCacheKey = useGetApiCacheKey_1.useGetApiCacheKey();
    return use_mutation_1.default(function (_a) {
        var params = _a.params, body = _a.body;
        return policyApi.updateNotes(params, body);
    }, {
        onMutate: function (_a) {
            var input = _a.input;
            var key = getCacheKey(routes_1.routes.policyByUuid.getUrl(input.params));
            var current = swr_1.cache.get(key);
            return swr_1.mutate(getCacheKey(routes_1.routes.policyByUuid.getUrl(input.params)), function () { return (__assign(__assign({}, current), { details: __assign(__assign({}, current.details), { notes: input.body.notes }) })); }, false);
        },
        throwOnFailure: true,
    });
}
exports.useUpdatePolicyNotes = useUpdatePolicyNotes;
